<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal">
      <div class="modal-header">
        <h3>{{ title }}</h3>
        <button @click="closeModal" class="btn-close">&times;</button>
      </div>
      <div class="modal-body">
        <div class="form-masterdata">
          <form @submit.prevent="updateMasterData">
            <div>
              <label>Üblicher Arbeitsbeginn</label>
              <input type="time" v-model="usualStart" required>
            </div>
            <div>
              <label>Übliches Arbeitsende</label>
              <input type="time" v-model="usualEnd" required>
            </div>
            <div>
              <label>Beginn der üblichen Pausenzeit</label>
              <input type="time" v-model="usualBreakStart" required>
            </div>
            <div>
              <label>Ende der üblichen Pausenzeit</label>
              <input type="time" v-model="usualBreakEnd" required>
            </div>
            <div>
              <label>Feiertagsregion</label>
              <select v-model="publicHolidayRegion" required>
                <option v-for="item in publicHolidayRegions" :key="item.guid" :value="item.guid">{{ item.name }}
                </option>
              </select>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" @click="updateMasterData">Speichern</button>
        <button @click="closeModal">Schließen</button>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/service';

export default {
  name: 'MasterDataModal',
  props: {
    title: {
      type: String,
      default: 'Modal Title',
    },
    show: {
      type: Boolean,
      default: false,
    },
    latestMasterData: {
      type: Object,
      default: () => ({
        usualStart: '',
        usualEnd: '',
        usualBreakStart: '',
        usualBreakEnd: '',
        updated: '',
        publicHolidayRegion : 'Deutschland Nordrhein-Westfalen'
      })
    },
    publicHolidayRegions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      usualStart: this.latestMasterData.workWindowStart,
      usualEnd: this.latestMasterData.workWindowEnd,
      usualBreakStart: this.latestMasterData.breakWindowStart,
      usualBreakEnd: this.latestMasterData.breakWindowEnd,
      updated: this.latestMasterData.updated,
      publicHolidayRegion: this.latestMasterData.publicHolidayRegion
    };
  },
  computed: {
    isVisible() {
      return this.show;
    },
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.initializeData();
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    update() {
      this.$emit('update');
      this.closeModal();
    },
    initializeData() {
      this.usualStart = this.latestMasterData.workWindowStart || '';
      this.usualEnd = this.latestMasterData.workWindowEnd || '';
      this.usualBreakStart = this.latestMasterData.breakWindowStart || '';
      this.usualBreakEnd = this.latestMasterData.breakWindowEnd || '';
      this.updated = this.latestMasterData.updated || '';
      this.publicHolidayRegion = this.latestMasterData.publicHolidayRegion || '';
    },
    updateMasterData() {
      apiService.post(`/User/InsertMasterData`,{
        updated: new Date().toJSON(),
        usualStart: this.usualStart,
        usualEnd: this.usualEnd,
        usualBreakStart: this.usualBreakStart,
        usualBreakEnd: this.usualBreakEnd,
        publicHolidayRegion: this.publicHolidayRegion
      })
        .then(() => {
          this.update();
        }).catch(() => {
          console.log("UpdateDay Error!");
        }).finally(() => {
          console.log("UpdateDay Finally!");
        })
    }
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal {
  background: #fff;
  padding: 2rem;
  border-radius: 5px;
  width: 600px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  margin: 15px 0;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #4d4d4d;
}

.btn-close:hover {
  color: #c0c0c0;
}

.form-masterdata {
  margin: auto;
  /* width: 30%; */
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.form-masterdata h2 {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 1rem;
}

.form-masterdata form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-masterdata label,
.form-masterdata input,
.form-masterdata select {
  display: block;
  width: 100%;
}

.form-masterdata input,
.form-masterdata button,
.form-masterdata select {
  padding: .5rem .75rem;
}

.form-masterdata label {
  margin-bottom: .5rem;
  font-weight: 600
}

.form-masterdata input:focus-visible,
.form-masterdata select:focus-visible {
  outline: 3px solid #5b97d484;
  border-radius: 2px;
}

.modal-footer {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.modal-footer button {
  border: none;
  background-color: #4d4d4d;
  border-radius: 5px;
  font-size: 1rem;
  color: white;
  font-weight: 600;
  padding: .5rem .75rem;
}

.modal-footer button:hover {
  cursor: pointer;
  background-color: #c0c0c0;
}
</style>